import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { GeographyFilter } from "./GeographyFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultGeographySlice, type GeographySlice } from "./slice";

export type { GeographySlice } from "./slice";
export { defaultGeographySlice } from "./slice";

export const geographyModule: FilterModule<GeographySlice, Lookups> = {
  key: "geography",
  defaultSlice: defaultGeographySlice,
  Component: GeographyFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
